<template>
  <div class="passwordetail">
    <div class="passwordetail_title">
      <p>信息变更详情</p>
    </div>
    <div class="labelFather" style="margin-top: 30px">
      <div class="labelChange" v-for="(item, index) in tableData" :key="index">
        <span>{{ item.type }}</span>
        <el-image
          v-if="
            (item.type == '证件照' || item.type == '证书照片') &&
            item.changeBefore
          "
          fit="scale-down"
          style="width: 100px; height: 100px"
          :src="item.changeBefore"
          :preview-src-list="[item.changeBefore]"
        >
        </el-image>
        <p v-else>{{ item.changeBefore }}</p>
        <span>变更为</span>
        <el-image
          v-if="item.type == '证件照' || item.type == '证书照片'"
          style="width: 100px; height: 100px"
          fit="scale-down"
          :src="item.changeAfter"
          :preview-src-list="[item.changeAfter]"
        >
        </el-image>
        <p v-else>{{ item.changeAfter }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { infoChangeDetail } from "../../api/moudles/user.js";
export default {
  data() {
    return {
      tableData: [],
    };
  },
  created() {
    if (this.$route.params.id) {
      this.newId = this.$route.params.id;
      this.infoChangeDetail(this.$route.params.id);
    }
  },
  methods: {
    async infoChangeDetail(code) {
      await infoChangeDetail({
        data: {
          applyCode: code,
        },
        success: (res) => {
          this.tableData = res.data;
        },
      });
    },
  },
};
</script>

<style scoped>
.passwordetail {
  min-height: 650px;
  padding-bottom: 20px;
  background-color: #fff;
}

.passwordetail_title {
  height: 60px;
  font-weight: 500;
  font-size: 22px;
  line-height: 60px;
  padding-left: 20px;
  border-bottom: 1px solid #f2f2f2;
}

.p-title {
  color: #035bab;
  font-size: 16px;
  font-weight: 600;
  text-align: left;
}

/* 详情 */
.labelFather {
  /* width: 1200px; */
  min-height: 50px;
  height: auto;
  display: flex;
  flex-wrap: wrap;
}

.labelChange {
  display: flex;
  min-width: 600px;
  min-height: 50px;
  height: auto;
  line-height: 50px;
}

.labelChange span {
  display: block;
  min-width: 120px;
  text-align: right;

  font-size: 14px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 600;
  color: #333333;
}

.labelChange p {
  display: block;
  min-width: 130px;
  text-align: left;
  padding-left: 20px;

  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 500;
  color: #1890ff;
}

>>> .el-image {
  margin: 0 25px;
}

.dashed {
  /* 虚线 */
  width: 630px;
  margin-top: 20px;
  margin-left: 50px;
  height: 1px;
  background-image: linear-gradient(to right, #dbdbdb 100%, transparent 50%);
  background-size: 8px 1px;
  background-repeat: repeat-x;
}

.labelSpecil {
  margin: 20px 0;
}

.labeldiv {
  display: flex;
  min-height: 30px;
}

.labeldiv span {
  display: block;
  width: 220px;
  text-align: right;
  line-height: 30px;
  font-size: 14px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 600;
  color: #333333;
}

.labeldiv p {
  line-height: 30px;
  display: block;
  width: auto;
  text-align: left;
  padding-left: 20px;
  cursor: pointer;

  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 500;
  color: #1890ff;
}

.labelImgList {
  margin-left: 20px;
  display: flex;
  flex-flow: column;
}
</style>
